module.exports = __webpack_public_path__ + "img/744.fc45787b.jpg";